import { DIMENSION_NAME } from 'src/constants/LoggerConstants';

export function getClickMetricDimensions(componentName: string, action: string) {
  return {
    [DIMENSION_NAME.COMPONENT_NAME]: componentName,
    [DIMENSION_NAME.ACTION]: action,
  };
}
